// Date formatters used by the message room. Pure helpers so they can be
// tested in isolation and re-used by any future message widget.
export function fmtTime(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleTimeString("ar-IQ", { hour: "2-digit", minute: "2-digit" });
  } catch {
    return "";
  }
}

export function fmtDayLabel(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const that = new Date(d); that.setHours(0, 0, 0, 0);
  const days = Math.round((today - that) / 86400000);
  if (days === 0) return "اليوم";
  if (days === 1) return "أمس";
  if (days < 7) return d.toLocaleDateString("ar-IQ", { weekday: "long" });
  return d.toLocaleDateString("ar-IQ", { day: "numeric", month: "long", year: "numeric" });
}
